import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {AgentService} from "app/services";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {fetchAllAgents, fetchAllSubAgents} from "./agents-list.slice";
import AuthService from "app/services/auth.service";
import {ROLES} from "app/constants/roles";

interface DeleteAgentStateParams {
  id: string;
  onSuccess?: Function;
  onError?: Function;
}

const isUserAgent = (): boolean => {
  const user = AuthService.handleAuthentication();
  if (!user) return false;
  // @ts-ignore
  const authorities = user.authorities || [];
  const isAdmin = authorities.includes(ROLES.ROLE_ADMIN);
  const isAgent = authorities.includes(ROLES.ROLE_AGENT) && !isAdmin;
  return isAgent;
};

export const deleteAgent = (params: DeleteAgentStateParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await AgentService.deleteAgent(params.id);
    if (response.status >= 200 || response.status < 300) {
      dispatch(setSuccess(true));
      const isAgent = isUserAgent();
      const lang = localStorage.getItem('i18nextLng');
      const message = lang === 'en' 
          ? (isAgent ? 'Sub-Agent deleted successfully!' : 'Agent deleted successfully!')
          : (isAgent ? 'Sub-Agjenti u fshi me sukses!' : 'Agenti u fshi me sukses!');
      dispatch(successMsg(message));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(''));
      // @ts-ignore
      dispatch(isAgent ? fetchAllSubAgents() : fetchAllAgents());
    }
    dispatch(setLoading(false));
  } catch (err) {
    dispatch(setLoading(false));
    dispatch(errorMsg(err.data.message));
    if (params.onError) params.onError();
    dispatch(setError(err.data.message));
  }
}

interface DeleteAgentSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: DeleteAgentSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'agent/delete-agent',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setSuccess: (state, action) => {
      state.success = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;